/* eslint-disable no-nested-ternary */
import React from "react";
import { differenceInDays } from "date-fns";
import { useFlags } from "launchdarkly-react-client-sdk";

import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import LeaveType from "components/Screens/Timeoff/ManageTimeoff/Common/LeaveType";
import ChipComp from "components/common/Chip";
import LeaveBreakdownChips from "components/common/LeaveBreakdownChips";
import DocumentsList from "components/Screens/Timeoff/ManageTimeoff/PendingLeaves/PendingLeavesCard/DocumentsList";
import { convertDate } from "components/Screens/CommonUtils";

function TimeoffBreakdown({
  pending,
  collapsed,
  noOfLeaves,
  dateFrom,
  createdAt,
  leaveStatus,
  leaveType,
  scheduleTextClass,
  paid,
  unpaid,
  advance,
  employeeId,
  documents,
  anniversaryBasedTimeOff,
  swapDateFrom,
  swapDateTo,
  swapDescription,
}) {
  const { swappedLeavesRevamp } = useFlags();

  return (
    <div className={pending || !collapsed ? "pending-timeoff-details-wrapper" : "space-y-1 pb-1"}>
      <div className="pending-timeoff-details">
        <div
          className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}
          id="total-timeoff-used"
        >
          Total time-off used
        </div>
        <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
          <ChipComp
            size="small"
            variant="outlined"
            id="no-of-leaves"
            labelClass="para-body-s-regular"
            label={`${noOfLeaves} ${noOfLeaves === 1 ? "leave" : "leaves"}`}
          />
        </div>
      </div>

      {leaveType === "Swapped" && swapDateFrom && swapDateTo && swappedLeavesRevamp ? (
        <div className="pending-timeoff-details">
          <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>Swap with</div>
          <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
            <ChipComp
              variant="outlined"
              id="swap-dates"
              labelClass="para-body-s-regular"
              label={
                <div className="flex items-center">
                  <span className="para-body-s-regular">
                    {swapDateFrom === swapDateTo
                      ? convertDate(swapDateFrom)
                      : `${convertDate(swapDateFrom)} - ${convertDate(swapDateTo)}`}
                  </span>
                  {swapDescription && (
                    <Tooltip title={swapDescription} placement="top">
                      <InfoOutlinedIcon className="swap-info-icon ml-05" />
                    </Tooltip>
                  )}
                </div>
              }
            />
          </div>
        </div>
      ) : leaveType !== "Unpaid" && pending ? (
        <div className="pending-timeoff-details">
          <LeaveBreakdownChips
            {...{
              employeeId,
              leaveType,
              paid,
              unpaid,
              advance,
              pending,
              collapsed,
              scheduleTextClass,
              leavesApplied: noOfLeaves,
            }}
          />
        </div>
      ) : (
        leaveType !== "Unpaid" &&
        leaveType !== "Swapped" && (
          <div className="pending-timeoff-details">
            <LeaveBreakdownChips
              {...{ employeeId, leaveType, paid, unpaid, advance, pending, collapsed, scheduleTextClass }}
            />
          </div>
        )
      )}

      <div className="pending-timeoff-details">
        <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>Notice Period</div>
        <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
          <ChipComp
            size="small"
            variant="outlined"
            labelClass="para-body-s-regular"
            id="notice-period"
            label={`${differenceInDays(new Date(dateFrom), new Date(createdAt))} Days`}
          />
        </div>
      </div>

      {anniversaryBasedTimeOff && (
        <DocumentsList
          pending={pending}
          source="customer-timeoff"
          collapsed={collapsed}
          documents={documents}
          scheduleTextClass
          employeeId={employeeId}
          maxChipsPerRow={!pending ? 1 : 3}
        />
      )}

      <div className="pending-timeoff-details">
        <p className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>Status</p>
        <span className={pending || !collapsed ? "" : "ml-1"}>
          <LeaveType type={pending ? "Pending" : leaveStatus} />{" "}
        </span>
      </div>
    </div>
  );
}

export default TimeoffBreakdown;
